import {
  parse,
  isValid,
  startOfDay,
  subYears,
  differenceInYears
} from "date-fns";

const BRAZILIAN_DATE_PATTERN = /^(\d{2})[\/-](\d{2})[\/-](\d{4})$/;

const BIRTHDAY_MESSAGES = {
  required: "Data de nascimento é obrigatória",
  invalid: "Data de nascimento inválida",
  future: "Data futura não pode ser enviada",
  minimumAge: "É necessário ter 18 anos ou mais para se cadastrar"
};

const parseBrazilianDate = value => {
  if (!value || value.length !== 10) return null;

  const match = value.match(BRAZILIAN_DATE_PATTERN);
  if (!match) return null;

  const parsed = parse(value, "dd/MM/yyyy", new Date());
  if (!isValid(parsed)) return null;

  const day = parseInt(match[1], 10);
  const month = parseInt(match[2], 10);
  const year = parseInt(match[3], 10);

  if (
    parsed.getDate() !== day ||
    parsed.getMonth() + 1 !== month ||
    parsed.getFullYear() !== year
  ) {
    return null;
  }

  return startOfDay(parsed);
};

const validCalendarDate = value => {
  if (!value) return true;

  return parseBrazilianDate(value) !== null;
};

const notFutureDate = value => {
  const date = parseBrazilianDate(value);
  if (!date) return true;

  return date <= startOfDay(new Date());
};

const doctorMinimumAge = value => {
  const date = parseBrazilianDate(value);
  if (!date) return true;

  const minimumBirthday = subYears(startOfDay(new Date()), 18);

  return date <= minimumBirthday;
};

const maxAge = value => {
  const date = parseBrazilianDate(value);
  if (!date) return true;

  return differenceInYears(startOfDay(new Date()), date) < 150;
};

export {
  BIRTHDAY_MESSAGES,
  parseBrazilianDate,
  validCalendarDate,
  notFutureDate,
  doctorMinimumAge,
  maxAge
};
